// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 622 ? "8ef2bebe" : chunkId) + "." + {"622":"c720431c96de9133","759":"2a3e905929ee00bb"}[chunkId] + ".js";
};